import React from "react"
import { SubMenu } from "react-pro-sidebar"
import { NavLink } from "react-router-dom"
import { createUseStyles, useTheme } from "react-jss"
import { IChildMenuItem } from "../../util/interface"
import { SidebarMenuRecursive } from "./SidebarMenuRecursive"
import CustomIcon from "../CustomIcon"

const useStyles = createUseStyles({
  second_header: {
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
    letterSpacing: "0.438px",
  },
})
const SidebarSubMenu = ({ item }: { item: IChildMenuItem }) => {
  const theme: any = useTheme()
  const classes = useStyles({ theme })

  return (
    <SubMenu
      label={
        item.route ? (
          <NavLink to={item.route || ""} className={classes.second_header}>
            <span className="flex items-center">
              {item.svg && <CustomIcon path={item.svg} alt="" />}
              {item.label}
            </span>
          </NavLink>
        ) : (
          <span className="flex items-center">
            {item.svg && <CustomIcon path={item.svg} alt="" />}
            <div className={classes.second_header}> {item.label} </div>
          </span>
        )
      }
    >
      {item.child?.map((child) => (
        <SidebarMenuRecursive
          key={child.key}
          item={child}
        ></SidebarMenuRecursive>
      ))}
    </SubMenu>
  )
}

export default SidebarSubMenu
